export default "__VITE_ASSET__d01b511c__"